<template>
<div>
    <v-img :src="require('@/assets/maya/servicios/headers/cs.jpg')" max-height="420" class="px-3 px-sm-10 pt-6">
        <Topper />

        <v-card flat class="px-4 mt-8 mt-sm-12 pb-2 pb-sm-2 transparent" max-width="850">
            <div class="white--text font-weight-light" :class="($vuetify.breakpoint.xsOnly) ? 'display-1' : 'display-2'">
                CS1 y CS2
            </div>

            <div class="white mt-3" style="height:1px; max-width:420px"></div>

            <div class="mt-4 title white--text font-weight-regular" style="max-width:480px; line-height:1.3">
                <div>Controlled Shipping Level 1 y Controlled Shipping Level 2</div>
            </div>

            <div>
                <v-btn small text class="white--text ml-n4 mt-2" @click="$router.push('/servicios')">
                    <div class="d-flex align-center">
                        <v-icon size="12" color="white" class="mr-2 mt-1">fa-arrow-left</v-icon>
                        <div>Regresar a servicios</div>
                    </div>
                </v-btn>
            </div>
        </v-card>
    </v-img>

    <div class="white py-6 px-4 px-sm-0">
        <v-row class="">
            <v-col cols="12" sm="10" offset-sm="1" md="8" offset-md="1">
                <p>
                    <span class="primary--text font-weight-bold">Los servicios "Controlled Shipping Level 1" y "Controlled Shipping Level 2" o mejor conocidos como CS1 y CS2</span>, son procesos que consisten en el envío restringido de materiales al cliente, debido a fallas constantes causadas por el proveedor.
                </p>

                <div class="mt-4">
                    <div class="primary--text font-weight-bold">El servicio CS2</div>
                    <div>
                        El cliente requiere un envío controlado nivel 2 cuando el proveedor no ha logrado solucionar el problema en la etapa de CS1.  Este proceso deberá ser llevado a cabo en la planta del cliente y se realizará a través de una inspección aún más minuciosa ya que este debió ser inspeccionado en su totalidad en las instalaciones del proveedor.
                    </div>
                </div>

                <div class="mt-4">
                    <div class="primary--text font-weight-bold">Envíos Controlados o Restringidos</div>
                    <div>
                        Se llevan a cabo cuando un proveedor ha enviado “productos no conformes” a su cliente, es decir, cuando tienen uno o más defectos.
                        <br> <br>
                        El envío controlado requiere que el proveedor implemente un proceso de inspección inmediato para así clasificar el material o producto que no cuenta con la calidad esperada. De esta forma se podrá desarrollar un plan confiable de resolución de problemas.
                    </div>
                </div>

                <div class="mt-4">
                    <div class="primary--text font-weight-bold">El servicio CS1</div>
                    <div>
                        El proveedor, desde sus instalaciones, inspecciona en su totalidad la calidad de todos sus embarques.
                    </div>
                </div>

                <div class="mt-4 primary--text font-weight-bold">CS1: Envío controlado de Nivel 1</div>
                <ul>
                    <li>Se realizará una inspección total del producto con su proveedor.</li>
                    <li>Se deben implementar controles y acciones correctivas que eviten a toda costa errores a nivel producción.</li>
                </ul>

                <div class="mt-4 primary--text font-weight-bold">CS2: Envío controlado de Nivel 2</div>
                <ul>
                    <li>Sucede cuando el proveedor o fabricante del producto no logró corregir los problemas de calidad en la etapa del CS1.</li>
                    <li>Se mantienen controles de los envíos nivel 1.</li>
                    <li>Se deben realizar inspecciones adicionales y periódicas para garantizar la continuidad del control de calidad en todos los niveles.</li>
                    <li>Se realizará un análisis de la causa principal del problema, es decir, la causa que genera estos defectos en el producto.  De esta forma, se podrán tomar las mejores decisiones en adelante y así evitar riesgos</li>
                </ul>
            </v-col>
        </v-row>
    </div>

    <!-- CONTACT FORM -->
    <ContactForm />
</div>
</template>

<script>
import ContactForm from '@/components/ContactForm'

export default {
    components: {
        ContactForm
    },
    metaInfo: {
      title: 'CS1 y CS2'
    }
}
</script>
